// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoIFrame_wrapper__J5iX0"};